import { useLang } from 'hooks/lang';

import { FullTask } from 'entities';

import { Modal } from 'components/Blocks';

import { TaskDateChangeForm } from 'pages/Projects/components';

import { TaskOptionOverlayProps } from '../createTaskOptions';

export function TaskDateChangeModal({ close, isOpen, task }: TaskOptionOverlayProps) {
  const { t } = useLang();

  return (
    <Modal isOpen={isOpen} close={close} title={t('date-change-request')} width="min(90vw, 760px)">
      <TaskDateChangeForm task={task as FullTask} />
    </Modal>
  );
}
